import type { ClockPort, IdPort } from '../domain/ports'
import { createMonotonicIdFactory } from '../domain/helpers'

const nextId = createMonotonicIdFactory()

export const systemClock: ClockPort = {
  now: () => new Date(),
}

export const systemIds: IdPort = {
  create: (prefix) => nextId(prefix),
}
